<template>
  <section class="p-1">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Sanction Search Result</div>
        <div>
          <!-- <bread-crumb :bread-crumbs="['/Home']" /> -->
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-data-table fixed-header  height="55vh"
        :headers="headers"
        :items="sanctionResult"
        :items-per-page="10"
        dense
      ></v-data-table>
      <OverlayPageVue :showOverlay="loaderOverlay" />
    </v-card>
  </section>
</template>
<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import alerts from "@/mixins/alerts";
import setupService from "@/services/SetupService/setupService.js";
export default {
  name:"Sanction Search Result",
  mixins: [alerts],
  data: () => ({
    headers: [
      {
        text: "SDN No",
        value: "ofacKey",
        width: "100",
      },
      { text: "Name", value: "name", width: "100" },
      { text: "Address", value: "address", width: "100" },
      { text: "Remarks", value: "remarks", width: "200" },
      { text: "Source", value: "data_source", width: "100" },
    ],
    sanctionResult: [],
    loaderOverlay: false,
  }),
  components: {
    OverlayPageVue,
  },
  mounted() {
    this.getallSearchResult();
    console.log(this.$route.query.dataSource);
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loaderOverlay = false;
      }, 400);
    },
    async getallSearchResult() {
      this.loaderOverlay = true;
      const dataSource = this.$route.query.dataSource;
      try {
        const response = await setupService.getSearchresult(dataSource);
        if (response.data.status_code === 200) {
          this.sanctionResult = response.data.data;
          this.stoploader();
        }
        //  else if (response.data.status_code === 401) {
        //   this.sanctionResult = [];
        //   this.returnNewToken();
        //   this.getallSearchResult();
        //   this.stoploader();
        // }
        else {
          this.sanctionResult == [];
          this.stoploader();
        }
      } catch (error) {
        this.sanctionResult = [];
        this.stoploader();
        console.error(error);
      }
    },
  },
};
</script>
